
import { Component, Vue } from 'vue-property-decorator';
import { VueDaumPostcode } from 'vue-daum-postcode';
import { getUserInfo } from '@/api/user';
import { getBankInfoListAll } from '@/api/bankInfo';
import { parseRegisterNo, parseConcatNumber } from '@/utils/filters';
import { checkRegisterNo } from '@/api/client/user';
import { getEncData } from '@/api/client/nice';
import { getIndustryListAll } from '@/api/industry';
import { getOptionItemList } from '@/api/optionItem';
import UpdateConfirm from './components/UpdateConfirm.vue';
import { UserModule } from '@/store/modules/user';

@Component({
  components: {
    VueDaumPostcode,
    UpdateConfirm,
  },
})
export default class extends Vue {
  async mounted() {
    await this.getGreetingList();
    this.getUserInfo();
    this.getIndustryList();
    this.getBankList();
    this.getEncData();
  }

  get industryIdx() {
    return UserModule.industry;
  }

  private key = 0;

  private form: any = {
    userId: '',
    userPassword: null,
    passwordCheck: '',
    actualName: '',
    concatNumber: '',
    business: {
      companyName: '',
      bossName: '',
      companyAddress: '',
      companyAddressDetail: '',
      registerNo: '',
      registerFileUid: '',
      email: '',
      bankCode: '',
      accountNo: '',
      accountFileUid: '',
      accountHolder: '',
      profileFileUid: '',
      greeting: '',
      popbillId: '',
      taxType: 0,
    },
    businessIndustryIdx: null,
  };

  private apiUrl = process.env.VUE_APP_BASE_API;

  private clientApiUrl = process.env.VUE_APP_CLIENT_API;

  private loading = true;

  private findAddressVisible = false;

  private industryList: any = [];

  private bankList = [];

  private greetingList: any = [];

  private encData = '';

  private fileList: any = [];

  private accountFileList: any = [];

  private updateConfirmVisible = false;

  private passwordChangeVisible = false;

  private validatePasswordCheck = (rule:any, value:any, callback:any) => {
    if (value !== (this.$refs.form as any).model.userPassword) {
      callback(new Error('비밀번호가 일치하지 않습니다.'));
    } else {
      callback();
    }
  };

  private handleInputMangerTel() {
    this.form.business.managerTel = parseConcatNumber(this.form.business.managerTel);
  }

  private validateConcatNumber = (rule:any, value:any, callback:any) => {
    const regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
    const regPhone2 = /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))-(\d{3,4})-(\d{4})$/;
    if (!regPhone.test(value) && !regPhone2.test(value)) {
      callback(new Error('연락처 형식에 맞지 않습니다.'));
    } else {
      callback();
    }
  };

  /* eslint-disable */
  private validateRegisterNo = (rule:any, value:any, callback:any) => {
    const regRegisterNo = /^([0-9]{3})-?([0-9]{2})-?([0-9]{5})$/;
    if (!regRegisterNo.test(value)) {
      callback(new Error('사업자번호 형식에 맞지 않습니다.'));
    } else {
      checkRegisterNo({ registerNo: value }).then((res) => {
        if (!res.data.resultCode) callback(new Error(res.data.resultMessage));
        callback();
      }).catch(() => {
        return callback(new Error('사업자번호 검증 요청에 실패했습니다.'));
      });
    }
  };

  private fnChange() {
    this.passwordChangeVisible = !this.passwordChangeVisible;
    this.key++;
  }
  /* eslint-enable */

  private rules = {
    userPassword: [
      { required: true, message: '패스워드를 입력하세요.', trigger: ['change', 'blur'] },
      {
        min: 8,
        max: 20,
        message: '패스워드는 최소 8자, 최대 20자입니다.',
        trigger: ['change', 'blur'],
      },
    ],
    passwordCheck: [
      { required: true, message: '패스워드를 확인해주세요.', trigger: ['change', 'blur'] },
      { validator: this.validatePasswordCheck, trigger: ['change', 'blur'] },
    ],
    actualName: [
      { required: true, message: '성명을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    concatNumber: [
      { required: true, message: '연락처를 입력하세요.', trigger: ['change', 'blur'] },
      { validator: this.validateConcatNumber, trigger: ['change', 'blur'] },
    ],
    business: {
      companyName: [
        { required: true, message: '업체명을 입력하세요.', trigger: ['change', 'blur'] },
      ],
      bossName: [
        { required: true, message: '대표자명을 입력하세요.', trigger: ['change', 'blur'] },
      ],
      companyAddress: [
        { required: true, message: '업체주소를 입력하세요.', trigger: ['change', 'blur'] },
      ],
      registerNo: [
        { required: true, message: '사업자번호를 입력하세요.', trigger: ['change', 'blur'] },
        { validator: this.validateRegisterNo, trigger: 'blur' },
      ],
      registerFileUid: [
        { required: true, message: '사업자등록증을 업로드하세요.', trigger: ['change', 'blur'] },
      ],
      email: [
        // { required: true, message: '이메일을 입력하세요.', trigger: ['change', 'blur'] },
        { type: 'email', message: '이메일형식으로 입력하세요.', trigger: ['change', 'blur'] },
      ],
      bankCode: [
        { required: false, message: '정산은행을 선택하세요.', trigger: ['change', 'blur'] },
      ],
      accountNo: [
        { required: false, message: '계좌번호를 입력하세요.', trigger: ['change', 'blur'] },
      ],
      accountHolder: [
        { required: false, message: '예금주를 입력하세요.', trigger: ['change', 'blur'] },
      ],
      accountFileUid: [
        { required: false, message: '통장사본을 업로드하세요.', trigger: ['change', 'blur'] },
      ],
      profileFileUid: [
        { required: true, message: '프로필 사진을 업로드하세요.', trigger: ['change', 'blur'] },
      ],
      greeting: [
        { required: true, message: '인사말을 선택하세요.', trigger: ['change', 'blur'] },
      ],
      businessType: [
        { required: true, message: '업태를 입력하세요.', trigger: ['change', 'blur'] },
      ],
      businessCategory: [
        { required: true, message: '종목을 입력하세요.', trigger: ['change', 'blur'] },
      ],
      taxType: [
        { required: true, message: '계산서 유형을 선택하세요.', trigger: ['change', 'blur'] },
      ],
    },
    businessIndustryIdx: [
      { required: true, message: '업종을 선택하세요.', trigger: ['change', 'blur'] },
    ],
  }

  private getUserInfo() {
    getUserInfo().then((res) => {
      this.form = res.data;
      if (res.data.business.registerFile) {
        this.fileList.push({
          name: res.data.business.registerFile.originalName,
          url: `${this.apiUrl}attached-file/${res.data.business.registerFile.uid}`,
        });
      }
      if (res.data.business.accountFile) {
        this.accountFileList.push({
          name: res.data.business.accountFile.originalName,
          url: `${this.apiUrl}attached-file/${res.data.business.accountFile.uid}`,
        });
      }
      if (this.form.business.greetingIdx === '' || this.form.business.greetingIdx === null) {
        if (this.greetingList.length > 0) {
          this.form.business.greeting = this.greetingList[0].name;
          this.form.business.greetingIdx = this.greetingList[0].idx;
        }
      }
      this.loading = false;
    });
  }

  private getIndustryList() {
    getIndustryListAll().then((res) => {
      this.industryList = res.data;
    });
  }

  private getBankList() {
    getBankInfoListAll().then((res) => {
      this.bankList = res.data;
    });
  }

  private getEncData() {
    getEncData().then((res) => {
      this.encData = res.data;
    });
  }

  private getGreetingList() {
    getOptionItemList('GREETING').then((res) => {
      this.greetingList = res.data;
    });
  }

  private handleFindAddress() {
    this.findAddressVisible = !this.findAddressVisible;
  }

  private handleCompleteFindAddress(data: any) {
    this.handleFindAddress();
    this.form.business.companyAddress = data.roadAddress;
    this.form.business.companyAddressDetail = '';
  }

  private getIndustry() {
    const index = this.industryList.findIndex((x: any) => x.idx === this.form.businessIndustryIdx);
    if (index > -1) {
      return this.industryList[index].name;
    }
    return '';
  }

  private handleUploadSuccess(res: any, type: string) {
    if (type === 'registerFile') {
      this.form.business.registerFileUid = res.uid;
      this.fileList.push({
        name: res.originalName,
        url: `${this.apiUrl}attached-file/${res.uid}`,
      });
    }
    if (type === 'profile') {
      (this.$refs.profileUpload as any).uploadFiles = [];
      this.form.business.profileFileUid = res.uid;
    }
    if (type === 'accountFile') {
      this.form.business.accountFileUid = res.uid;
      this.accountFileList.push({
        name: res.originalName,
        url: `${this.apiUrl}attached-file/${res.uid}`,
      });
    }
  }

  /* eslint-disable */
  private handleBeforeUpload(file: File, type: string) {
    const isLimit = file.size / 1024 / 1024 < 10;
    const isImage = file.type.startsWith('image');
    const isPdf = file.name.endsWith('pdf');
    if (!isLimit) {
      this.$message.warning('파일 용량은 10MB 를 초과 할 수 없습니다.');
      return false;
    }
    if (type === 'profile') {
      if (!isImage) {
        this.$message.warning('이미지 파일만 업로드 가능합니다.');
        return false;
      }
    } else {
      if (!isPdf && !isImage) {
        this.$message.warning('PDF 파일 혹은 이미지 파일만 업로드 가능합니다.');
        return false;
      }
    }
    return true;
  }
  /* eslint-enable */

  private handleRemoveFile(type: string) {
    if (type === 'registerFile') {
      this.form.business.registerFileUid = null;
      this.fileList = [];
    }
    if (type === 'profile') this.form.business.profileFileUid = null;
    if (type === 'accountFile') {
      this.form.business.accountFileUid = null;
      this.accountFileList = [];
    }
  }

  private filterRegisterNo() {
    this.form.business.registerNo = parseRegisterNo(this.form.business.registerNo);
  }

  private handleVisibleUpdateConfirm() {
    (this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        this.updateConfirmVisible = !this.updateConfirmVisible;
      }
    });
  }

  private downloadFile(file: any) {
    // 가상 링크 생성
    const link = document.createElement('a');
    link.href = file.url;

    // 다운로드 속성 추가
    link.setAttribute('download', file.name);

    // 클릭하여 다운로드 시작
    link.click();
  }

  private handleNicePopup() {
    const nicePopup = window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
    (this.$refs.niceForm as HTMLFormElement).action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
    (this.$refs.niceForm as HTMLFormElement).target = 'popupChk';
    (this.$refs.niceForm as HTMLFormElement).submit();
    const loop = setInterval(() => {
      if (nicePopup && nicePopup.closed) {
        clearInterval(loop);
        if ((document.getElementById('actualName') as any).value && (document.getElementById('concatNumber') as any).value) {
          this.form.actualName = (document.getElementById('actualName') as any).value;
          this.form.concatNumber = (document.getElementById('concatNumber') as any).value;
        }
      }
    }, 400);
  }

  private handleChangeGreeting() {
    if (this.form.business.greetingIdx === 28) {
      this.form.business.greeting = '';
    } else {
      const titleIndex = this.greetingList.findIndex((option: any) => option.idx === this.form.business.greetingIdx);
      const titleOption = this.greetingList[titleIndex];
      this.form.business.greeting = titleOption.name;
    }
  }

  private setRegister() {
    // :to ="{name:'Certificate'}
    if (this.form.business.popbillId === null) {
      this.$message.error('팝빌 회원 아이디 생성중입니다. 생성된 이후에 인증서를 등록해 주세요.');
      // alert('팝빌 아이디 없음');
    } else {
      this.$router.push({ name: 'Certificate', params: { popbillId: this.form.business.popbillId } });
    }
  }

  private filterInput(event: any) {
    this.form.business.accountNo = this.form.business.accountNo.replace(/[^0-9-]/g, '');
  }
}
